import styles from './LandscapeProjectsImpactTargetOrganism.module.css';
import { FC } from 'react';
import { SortableTargetList } from '../../molecules';
import cn from 'classnames';
import { ProjectTargetResponseDto } from '../../../store/landscapeAPI/project/dto/response/project-target-response.dto';
import { Button } from '../../atoms';

interface LandscapeProjectsImpactTargetOrganismProps {
  listItems: ProjectTargetResponseDto[];
  setListItems: (
    items: ProjectTargetResponseDto[],
    from: number,
    to: number
  ) => void;
  handleDelete: (id: string) => void;
  handleSubmit: () => void;
  handleOnChange: (projectTarget: ProjectTargetResponseDto) => void;
  handleAddTarget: () => void;
}

const LandscapeProjectsImpactTargetOrganism: FC<
  LandscapeProjectsImpactTargetOrganismProps
> = ({
  listItems,
  setListItems,
  handleDelete,
  handleSubmit,
  handleOnChange,
  handleAddTarget,
}) => {
  return (
    <>
      <div className={cn(styles.wrapper)}>
        <SortableTargetList
          listItems={listItems}
          setListItems={setListItems}
          handleDelete={handleDelete}
          handleOnChange={handleOnChange}
        />
      </div>
      <div className={cn(styles.inlineWrapper)}>
        <Button variant="dark" onClick={handleAddTarget}>
          Add Target
        </Button>
        <Button variant="dark" onClick={handleSubmit}>
          Save
        </Button>
      </div>
    </>
  );
};

export default LandscapeProjectsImpactTargetOrganism;
